import React, { Component } from "react";
import { Grid, Paper, Typography, CircularProgress, IconButton, Tooltip } from "@material-ui/core";
import PropTypes from "prop-types";
import CodeIcon from '@material-ui/icons/Extension';
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import { Dashboard as DashboardLayout } from "../../layouts";
import SettingsForm from "./components/SettingsForm";
import _ from "lodash";
import { connect } from "react-redux";
import { fetchChatbotSettings, updateChatbotSettings } from "../../redux/actions/chatbotActions";
import { showChatbot } from "../../redux/actions/chatActions";
import ColorForm from "./components/ColorForm/";
import CuesForm from "./components/CuesForm/";
import EmbedConnectorDialog from "../Connections/components/ConnectionDialog/embedConnectorDialog";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

// const useStyles = makeStyles((theme) => ({
//   root: {
//     backgroundColor: theme.palette.background.paper,
//     width: 500,
//   },
// }));

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`
  };
}

class ChatbotSettings extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false, tabSelected: 0, embedDialogOpen: false};
    this.loaded = false;
    this.currentSettings = {};
  }

  componentDidMount() {
    this.mounted = true;
    this.props.showChatbot(false);
  }

  componentWillMount() {
    if (_.isEmpty(this.props.skill)) return;

    this.loaded = false;
    this.fetchData();
  }

  componentWillReceiveProps(newProps, oldProps) {
    if (!_.isEmpty(newProps.skill) && !this.loaded && !this.state.isLoading) {
      this.fetchData();
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    this.props.showChatbot(true);
  }

  handleCancelEmbed = () => {
    this.setState({ embedDialogOpen: false });
  };

  openEmbedPromptWindow = async () => {
   if(!this.props.settings)return;
   if(this.props.settings.data.bot_file_name === ""){ 
      let initialConfig = {GUID: _.get(this.props.settings, "data.GUID"), ...this.props.settings.data.config };
      initialConfig.position = {desktopBottom: 10, desktopRight: 10, mobileRight: 10, mobileBottom: 10};
      initialConfig.first = true;
      await this.props.updateChatbotSettings(initialConfig);
    } 
   this.setState({ embedDialogOpen: true });
  };

  handleChange = (event, newValue) => {
    this.setState({ tabSelected: newValue });
  };

  fetchData = async () => {
    this.setState({ isLoading: true });
    await this.props.fetchChatbotSettings().then(() => {
      this.loaded = true;
      if (this.mounted) this.setState({ isLoading: false, currentSettings: _.get(this.props.settings, "data", {}) });
    });
  };

  updateColorSetting = colors => {
    const newState = { ...this.state };
    newState.currentSettings.config.color = colors;
    this.setState(newState);
  };

  // this component works well with both botSettings and cuesSettings
  updateBotSetting = botSettings => {
    const newState = { ...this.state };
    for (let x in botSettings) {
      newState.currentSettings.config[x] = botSettings[x];
    }
    this.setState(newState);
  };

  render() {
    const { classes, settings } = this.props;
    const { isLoading, tabSelected, embedDialogOpen, currentSettings } = this.state;
    return (
      <DashboardLayout>
        <EmbedConnectorDialog 
          open={embedDialogOpen}
          handleCancelEmbed={this.handleCancelEmbed}
          publicChatbotProps={settings?settings:{}}
        />
        <Grid container spacing={5}>
          {isLoading || !this.loaded ? (
            <Grid item lg={12} xs={12} md={12}>
              <Paper className={classes.root} elevation={1} style={{ position: "relative" }}>
                <CircularProgress style={{ marginLeft: "50%" }} />
              </Paper>
            </Grid>
          ) : (
            <Grid item md={12} style={{ maxWidth: "100%" }}>
              <Paper>
                <Tabs
                  value={tabSelected}
                  indicatorColor="primary"
                  textColor="primary"
                  onChange={this.handleChange}
                  aria-label="nav tabs example"
                  className={classes.tabRoot}
                >
                  <Tab label="Behavior Settings" {...a11yProps(0)} />
                  <Tab label="Color Settings" {...a11yProps(1)} />
                  <Tab label="Cues Settings" {...a11yProps(2)} />
                  <Tooltip title="Embed Assistant to your site">
                    <IconButton color="primary" onClick={this.openEmbedPromptWindow} style={{position: "absolute", right: 20, top:1.5}} ><CodeIcon style={{height: 25, width: 25}} /></IconButton>
                  </Tooltip>
                </Tabs>
                <TabPanel value={tabSelected} index={0}>
                  <Paper className={classes.root} elevation={1}>
                    <Grid item lg={8} xs={12} md={7}>
                      <Typography variant="h4" component="h4">
                        Configure AI Assistant name, logo image, welcome message and more
                      </Typography>
                      <Typography style={{ paddingTop: "10px" }} />
                      <br />
                      <br />
                      <SettingsForm data={currentSettings} updateSetting={this.updateBotSetting} />
                    </Grid>
                  </Paper>
                </TabPanel>

                <TabPanel value={tabSelected} index={1}>
                  <Paper className={classes.root} elevation={1}>
                    <Grid item xs={12}>
                      <Typography variant="h4" component="h4">
                        Select colors for your AI Assistant with a live preview of the color changes.
                      </Typography>
                      <Typography style={{ paddingTop: "10px" }} />
                      <br />
                      <br />
                      <ColorForm data={currentSettings} updateSetting={this.updateColorSetting} />
                    </Grid>
                  </Paper>
                </TabPanel>

                <TabPanel value={tabSelected} index={2}>
                  <Paper className={classes.root} elevation={1}>
                    <Grid item xs={12}>
                      <Typography variant="h4" component="h4">
                        Cues allow you to automatically engage visitors on your site with a popup message.
                      </Typography>
                      <Typography variant="body1" style={{ marginTop: "16px" }}>
                        Examples:
                        <br />
                        Cue users with a question based on the topic of the web page they’re accessing
                        <br />
                        Cue users with a coupon or discount offer
                      </Typography>
                      <br />
                      <br />
                      <CuesForm data={currentSettings} updateSetting={this.updateBotSetting} />
                    </Grid>
                  </Paper>
                </TabPanel>
              </Paper>
            </Grid>
          )}
        </Grid>
        
      </DashboardLayout>
    );
  }
}

const mapStateToProps = state => {
  return{
  settings: state.chatbotSettings.config,
  skill: state.skill
};}

ChatbotSettings = connect(mapStateToProps, { fetchChatbotSettings, showChatbot, updateChatbotSettings })(ChatbotSettings);

export default withStyles(styles)(ChatbotSettings);
